import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaintananceForm from "./MaintananceForm";

function MaintananceFormSave() {
  const { id } = useParams();
  return <MaintananceForm id={id} id2={0} FromCome={"SAVE"} />;
}

export default MaintananceFormSave;
